import React from 'react';

import { useContentRequirementsContext } from '../../../../features/RestrictNavigation/ContentRequirementsProvider';
import { HTMLWidgetDataProvider } from '../../../components/Widgets/HtmlWidget/HTMLWidgetDataProvider';
import { IFrame } from '../../../components/Widgets/HtmlWidget/IFrame';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { ExistingStudentWidgetProps } from '../Widget';
import { HTMLWidgetData, WidgetValue } from '@ael/core-api';

export const HTMLWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const htmlWidgetValue = widget.value as WidgetValue<HTMLWidgetData>;
  const { submitWidget } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);

  return (
    <StudentWidgetWrapper>
      <HTMLWidgetDataProvider assetId={htmlWidgetValue.data.assetId} widgetId={widget._id}>
        {(data) => data && <IFrame assetUrl={data.assetUrl} onFulfilled={fulfillCurrentWidget} />}
      </HTMLWidgetDataProvider>
    </StudentWidgetWrapper>
  );
};
